<template>
  <div>
    <template
      v-if="
        USER().rol === ROLES.SUPER ||
          USER().rol === ROLES.ADMIN ||
          USER().rol === ROLES.SANCIONES
      "
    >
      <b-row>
        <b-col md="12">
          <v-select
            placeholder="Seleccionar Articulo"
            :clearable="false"
            :options="listMotivos"
            taggable
            v-model="conceptoVal"
            @input="changeMotivo"
            class="mb-1 mt-1 select-size-sm"
          />
        </b-col>
        <b-col md="12">
          <b-form-textarea
            id="textarea-default"
            placeholder="Detalle"
            rows="2"
            size="sm"
            max-rows="3"
            disabled
            v-model="detalleReglamento"
          />
        </b-col>
        <b-col md="3" class="mt-1">
          <b-form-spinbutton
            id="sb-maxmin"
            v-model="cantidad"
            placeholder="Cant"
            size="sm"
            min="0"
            @input="calculaSubtotal"
          />
        </b-col>
        <b-col md="3" class="mt-1">
          <b-form-input
            placeholder="V.Unitario"
            size="sm"
            type="number"
            v-model="valorUnitario"
            @input="calculaSubtotal"
            class="m-0 p-1"
            :disabled="disabledValor"
          />
        </b-col>
        <b-col md="3" class="mt-1">
          <span
            variant="info"
            style=" font-size:16px; color:darkslategrey; display:flex; align-items:center; height:100%; font-weight: bold"
          >
            {{ valorTotal }} $
          </span>
        </b-col>
        <b-col md="2" class="mt-1">
          <b-button
            v-if="!showLoading"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="primary"
            size="sm"
            @click="insertMultaIndividual"
          >
            <span class="align-middle">Guardar</span>
          </b-button>
          <div v-if="showLoading" class="text-center ">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
        </b-col>
      </b-row>
      <div
        v-if="messageError != ''"
        style="position:absolute; width:80%; text-align:center"
      >
        <span style="font-size:12px; color:red">{{ messageError }}</span>
      </div>
      <b-row class="mt-2 cabecera">
        <b-col md="1" class="d-flex align-items-center">Cant</b-col>
        <b-col md="7" class="d-flex align-items-center p-0 mr-0 ml-1"
          >Concepto</b-col
        >
        <b-col md="1" class="d-flex align-items-center justify-content-center"
          >V.U</b-col
        >
        <b-col md="1" class="d-flex align-items-center justify-content-center"
          >V.Total</b-col
        >
      </b-row>
    </template>
    <b-overlay :show="showLoading" rounded="sm">
      <b-row
        v-for="item in listMultas"
        :key="item.id"
        style="border-bottom: 1px solid #e0e0e0; margin-top:10px; padding-bottom:5px; font-size:13px"
      >
        <b-col md="1" class="d-flex align-items-center">{{
          item.cantidad
        }}</b-col>
        <b-col md="7" class="d-flex align-items-center p-0 mr-0 ml-1">{{
          item.concepto
        }}</b-col>
        <b-col
          md="1"
          class="d-flex align-items-center justify-content-center"
          >{{ item.v_unitario }}</b-col
        >
        <b-col md="1" class="d-flex align-items-center">{{
          item.v_total
        }}</b-col>
        <b-col md="1" class="d-flex align-items-center ml-1"
          ><b-button
            v-if="item.is_tarjeta != 's' && item.bloquear != 's'"
            @click="deleteMulta(item.id_multa, item.bloquear)"
            variant="flat-primary"
            class="btn-icon"
            size="sm"
          >
            <feather-icon size="14" icon="Trash2Icon" /> </b-button
        ></b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  // BBadge,
  BFormInput,
  BFormTextarea,
  BFormSpinbutton,
  BOverlay,
  BSpinner,
  //   BDropdownForm,
  //   BFormGroup,
  //   BDropdown,
  //  xxx,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, computed } from '@vue/composition-api'
import vSelect from 'vue-select'
import apiCall from '../../utils/apiCall'
import { URL, USER, ROLES } from '../../utils/variables'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    // BBadge,
    BFormInput,
    BFormTextarea,
    BFormSpinbutton,
    BOverlay,
    BSpinner,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    listMultas: Array,
    listMotivos: Array,
    dataPartido: Object,
    categoriaSeleccionada: Object,
    idEquipo: String,
  },
  setup(props) {
    const cantidad = ref(null)
    const valorUnitario = ref(null)
    const valorTotal = ref(0.0)
    const conceptoVal = ref({ value: null, label: 'Seleccionar artículo' })
    const detalleReglamento = ref('')
    const showLoading = ref(false)
    const messageError = ref(null)
    const { postApi } = apiCall()

    function calculaSubtotal() {
      if (cantidad.value !== null && valorUnitario.value !== null) {
        valorTotal.value = (cantidad.value * valorUnitario.value).toFixed(2)
      }
    }

    function changeMotivo(item) {
      cantidad.value = 0
      if (item.value === undefined) {
        detalleReglamento.value = ''
        valorUnitario.value = null
      } else if (item.value !== undefined) {
        detalleReglamento.value = `${
          item.dataReglamento.detalle == null ? '' : item.dataReglamento.detalle
        } `
        valorUnitario.value = item.dataReglamento.valor
        // console.log(item.value)
        if (item.value === undefined) {
          item.value = null
        }
      }
    }
    function hasErrorForm() {
      // console.log(conceptoVal.value)
      let error = false
      if (conceptoVal.value === undefined || conceptoVal.value === null) {
        error = true
        messageError.value = 'Concepto no debe ser vacio'
      } else if (
        cantidad.value === undefined ||
        cantidad.value === null ||
        cantidad.value === 0
      ) {
        error = true
        messageError.value = 'La cantidad ingresada es incorrecta'
      } else if (
        valorUnitario.value === null ||
        valorUnitario.value === undefined ||
        Number(valorUnitario.value) <= 0 ||
        valorUnitario.value === ''
      ) {
        error = true
        messageError.value = 'valor unitario no válido'
      } else {
        error = false
        messageError.value = ''
      }
      return error
    }
    function resetValores() {
      messageError.value = ''
      conceptoVal.value = undefined
      cantidad.value = null
      valorUnitario.value = null
      detalleReglamento.value = null
      valorTotal.value = null
      showLoading.value = false
    }
    async function insertMultaIndividual() {
      // console.log(conceptoVal.value.value)
      valorTotal.value = cantidad.value * valorUnitario.value
      const data = {
        idEquipo: props.idEquipo,
        idPartido: props.dataPartido.id_partido,
        vUnitario: valorUnitario.value,
        vTotal: valorTotal.value,
        cantidad: cantidad.value,
        concepto: conceptoVal.value.label,
        idCampeonato: props.dataPartido.id_campeonato,
        id_motivo_sancion: conceptoVal.value?.value ?? null,
      }
      // console.log(data)
      const hasError = hasErrorForm()
      if (!hasError) {
        showLoading.value = true
        const path = 'ApiMultas/insertMultaIndividual'
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          const aux = {
            concepto: data.concepto,
            v_unitario: data.vUnitario,
            v_total: data.vTotal,
            cantidad: data.cantidad,
            id_multa: response.data.id_multa,
            bloquear: 'n',
          }
          props.listMultas.unshift(aux)
          resetValores()
        }
        // showLoading.value = false
      }
    }

    async function deleteMulta(idMulta, bloquearDato) {
      const data = {
        id_multa: idMulta,
        rol: USER().rol,
        bloquear: bloquearDato,
        cancelado: false,
        hayDetalleBloqueado: false,
      }
      const path = 'ApiMultas/deleteMulta'
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        const found = props.listMultas.findIndex(
          // eslint-disable-next-line
          element => element.id_multa === data.id_multa
        )
        props.listMultas.splice(found, 1)
      }
    }
    function calculaTotal() {
      let total = 0
      props.listMultas.forEach(element => {
        total += Number(element.v_total)
      })
      return total.toFixed(2)
    }
    const disabledValor = computed(() => {
      // console.log(conceptoVal.value)
      if (conceptoVal.value !== undefined) {
        if (conceptoVal.value.value === undefined) {
          return false
        }
        return true
      }
      return true
    })
    const totalPagar = computed(() => calculaTotal())

    return {
      totalPagar,
      cantidad,
      valorUnitario,
      valorTotal,
      conceptoVal,
      insertMultaIndividual,
      calculaSubtotal,
      messageError,
      showLoading,
      deleteMulta,
      USER,
      ROLES,
      changeMotivo,
      detalleReglamento,
      disabledValor,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
